import { Theme } from '~/theme';

const getDataPointColor = (index: number, theme: Theme) => {
  const colors = theme.getTokens().colors.chart;
  return colors[index % colors.length];
};

export default getDataPointColor;
